<template>
  <v-card align="center" justify="center" light min-width="25vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('createHitMistake') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <v-form v-model="valid">
        <p class="text-center mt-3">{{ $t('createConsideration') }}</p>
        <v-select v-model="typeSelected" small-chips :items="types" item-text="text" item-value="value" :rules="typeRules" :label="$t('form.type.label')" outlined/>
        <v-text-field :label="$t('form.considerationName.label',{typeName: typeSelected})" :hint="(typeSelected === 'Mistake')? $t('form.considerationName.hint1') : $t('form.considerationName.hint2') "
                      :placeholder="(typeSelected === 'Mistake')? $t('form.considerationName.placeholder1') : $t('form.considerationName.placeholder2') "
                      v-model="name" :rules="nameRules" counter="17" outlined/>
        <v-btn class="my-3" :disabled="!valid" @click="createConsideration">{{ $t('create') }} {{ typeSelected }}</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/consideration';
import { mapMutations } from 'vuex';

export default {
  name: "AddConsideration",
  data() {
    return {
      valid: false,
      nameRules: [
        n => !!n || this.$t('form.considerationName.rule1'),
        n => (n && n.length <= 17) || this.$t('form.considerationName.rule2'),
      ],
      typeRules: [
        t => !!t || this.$t('form.type.rule'),
      ],
      types: [
          { text: this.$t('types.hit'), value: 'Hit' },
          { text: this.$t('types.mistake'), value: 'Mistake' },
          { text: this.$t('types.other'), value: 'Other' },

      ],
      name: '',
      typeSelected: 'Hit',
    };
  },
  methods: {
    ...mapMutations(['setConsiderations']),
    createConsideration() {
      let consideration = {
        name: this.name,
        type: this.typeSelected.toUpperCase(),
        user: { id: this.$store.state.user.id },
      };

      Repository.createConsideration(consideration).then((response) => {
        if (response.status < 400) {
          Repository.getConsiderationsByUser(this.$store.state.user.id).then((secondResponse) => {
            if(secondResponse.status < 400) {
              this.setConsiderations(secondResponse.data);
              alert(this.$t('successfullCreation',{selectedType: this.typeSelected}));
            }
          });
          this.close();
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>


<i18n>
{
  "en":{
    "createHitMistake": "Create Hit/Mistake",
    "createConsideration": "Create a consideration for your trades.",
    "create": "Create",
    "successfullCreation": "{selectedType} was successfully created!",

    "form":{
      "type":{
        "label":"Type",
        "rule": "Type is required"
      },
      "considerationName":{
        "label": "Name for your {typeName}",
        "hint1": "E.g. overtrade, fast close.",
        "hint2": "E.g. perfect entry, well managed.",
        "placeholder1": "E.g. overtrade, fast close.",
        "placeholder2": "E.g. perfect entry, well managed.",
        "rule1": "Name is required",
        "rule2": "Max 17 characters"
      }
    },

    "types":{
      "hit": "Hit",
      "mistake": "Mistake",
      "other": "Other"
    }

  },
  "es":{
    "createHitMistake": "Crear Acierto/Error",
    "createConsideration": "Crear consideración para tus trades",
    "create": "Crear",
    "successfullCreation": "¡{selectedType} ha sido creado exitosamente!",

    "form":{
      "type":{
        "label":"Tipo",
        "rule": "El tipo es obligatorio"
      },
      "considerationName":{
        "label": "El nombre de tu {typeName}",
        "hint1": "Ejemplo: Sobre operar, Cierre temprano.",
        "hint2": "Ejemplo: Entrada perfecta, buena gestión.",
        "placeholder1": "Ejemplo: Sobre operar, Cierre temprano.",
        "placeholder2": "Ejemplo: Entrada perfecta, buena gestión.",
        "rule1": "El nombre es obligatorio",
        "rule2": "Máximo 17 caracteres"
      }
    },

    "types":{
      "hit": "Acierto",
      "mistake": "Error",
      "other": "Otro"
    }
  }
}
</i18n>
